import { useApiMutation, useLocalizedApiQuery } from "../services/react-query";

export const useGetSessions = (params, queryOptions = {}) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["sessions", params], ...queryOptions },
    fetchOptions: { url: "/sessions", method: "GET", params },
  });

export const useGetPublicSessions = (params) =>
  useLocalizedApiQuery({
    queryOptions: {
      queryKey: ["sessions", "public", params],
      enabled: !!params.eventId,
    },
    fetchOptions: { url: "/public/sessions", method: "GET", params },
  });

export const useGetSession = (id) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["session", { id }], enabled: !!id },
    fetchOptions: { url: `/sessions/${id}`, method: "GET" },
  });

export const usePatchSession = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchSession" },
    fetchOptions: { url: `/sessions/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["sessions"], ["session"], ["sessionTags"]],
    successMessage: { title: "Session has been updated", color: "green" },
  });

export const useCreateSession = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateSession" },
    fetchOptions: { url: "/sessions", method: "POST" },
    invalidateQueryKeys: [["sessions"]],
    successMessage: { title: "Session has been created", color: "green" },
  });

export const useDeleteSession = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteSession" },
    fetchOptions: { url: "/sessions", method: "DELETE" },
    invalidateQueryKeys: [["sessions"]],
    successMessage: { title: "Session has been deleted", color: "green" },
  });

export const usePollsToggle = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "sessionPolls" },
    fetchOptions: {
      url: "/polls/toggleVisibilityOnMobileHomepage",
      method: "PATCH",
    },
    invalidateQueryKeys: [["sessions"]],
    successMessage: { title: "Polls have been toggled", color: "green" },
  });

export const useCancelSession = (sessionId, isCanceled) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCancelSession" },
    fetchOptions: { url: `/sessions/${sessionId}/cancel`, method: "PATCH" },
    invalidateQueryKeys: [["sessions"], ["session"]],
    successMessage: {
      title: `${isCanceled ? "Session has been restored successfully" : "Session has been canceled successfully"}`,
      color: "green",
    },
  });

export const useDeleteSessionLink = (sessionId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteSessionLink" },
    fetchOptions: { url: `/sessions/${sessionId}/links`, method: "DELETE" },
    invalidateQueryKeys: [["sessions"], ["session"]],
    successMessage: { title: "Session link has been deleted", color: "green" },
  });

export const useCreateSessionLink = (sessionId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateSessionLink" },
    fetchOptions: { url: `/sessions/${sessionId}/links`, method: "POST" },
    invalidateQueryKeys: [["sessions"], ["session"]],
    successMessage: { title: "Session link has been created", color: "green" },
  });

export const useEditSessionLink = ({ sessionId, linkId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useEditSessionLink" },
    fetchOptions: {
      url: `/sessions/${sessionId}/links/${linkId}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["sessions"], ["session"]],
    successMessage: { title: "Session link has been updated", color: "green" },
  });
